import React from 'react';
import {Box, Grid} from '@material-ui/core';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import CircularProgress from '@mui/material/CircularProgress';
import {MetaTags} from 'react-meta-tags';
import { makeStyles } from '@material-ui/core/styles';
import Header from "./HeaderMy";
import LeftDrawer from "../components/LeftDrawer";
import '../styles/bizofficer-a.css';
import axios from 'axios';
import {API_URL} from '../utils/EnvVars';
import UpdateEmail from '../components/UpdateEmail';
import UpdatePhone from '../components/UpdatePhone';
import DeleteAccountOtp from '../components/DeleteAccountOtp';

const useStyles = makeStyles((theme) => ({
	content: {
	  [theme.breakpoints.up('md')]: {
		marginLeft:240,
		marginTop:60,
	  },
	  padding: theme.spacing(1),
	},
  }));

  export default function Execute() {
	const classes = useStyles();
	const etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));
	const [picture, setPicture] = React.useState("");
	const [showAlert, setShowAlert] = React.useState(false);
	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [deleteAccountProgress, setDeleteAccountProgress] = React.useState(false);
	//const [undoDeleteAccountProgress, setUndoDeleteAccountProgress] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState(""); 
	const childRefUpdateEmail = React.useRef();
	const childRefUpdatePhone = React.useRef();
	const childRefDeleteAccount = React.useRef();
	const [deleteAccountToken, setDeleteAccountToken] = React.useState("");
	const [mobileOs, setMobileOs] = React.useState(""); 
	
	var vertical='top',horizontal='center';

	function getMobileOperatingSystem() {
		///alert(navigator.platform);		
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;
		// Windows Phone must come first because its UA also contains "Android"
		if (/windows phone/i.test(userAgent)) {
			setMobileOs("Window");
			return;
		}
		if (/android/i.test(userAgent)) {
			setMobileOs("Android");
			return;
		}
		if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
			setMobileOs("iOS");
			return;
		}
		
		return;
	}
	

	function hideAlert(){
		setShowAlert(false);
	}

	React.useEffect(() => {
		getMobileOperatingSystem();
		if(etlStudentObj && etlStudentObj.profilePic && etlStudentObj.profilePic.length>0){
			setPicture(etlStudentObj.profilePic);			
		}	
	}, [etlStudentObj]); 

	function uploadFile() {

		if(document.querySelector('#profilepic')){ 
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
					'loginId': etlStudentObj.loginId,
					'token': etlStudentObj.token,
					'device': 'web'
				}
			}; 
			const data = new FormData();
			var browseFile = document.querySelector('#profilepic');
			if(browseFile && browseFile.files[0] && browseFile.files[0].name.length>0){
				data.append("uploadedFiles", browseFile.files[0]);
			}
             
			axios.post(API_URL+'/student-profile-pics-upload', data, axiosHeader)
			.then((response) => {
				///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response && response.status===200 && response.data.responseTxt==="success"){
					//alert("fileName: "+response.data.obj.virtualUrlFile);
					setPicture(response.data.obj.virtualUrlFile);
					etlStudentObj.profilePic=response.data.obj.virtualUrlFile;
					localStorage.setItem("etlStudentObj", JSON.stringify(etlStudentObj));

					return false;

				}else{
					setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Your picture could not be uploaded.");			
					return false;
				}
			}).catch((error) => {
				setShowAlert(true);
				setAlertMessage(""+error);			
				return false;
			})	
		}		

	}

	function removeFile() {

		if(picture && picture.length>0){ 
			let picArr = picture.split("/");			
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
					'loginId': etlStudentObj.loginId,
					'token': etlStudentObj.token,
					'device': 'web'
				}
			}; 
			const data = new FormData();
			data.append("fileName", picArr[picArr.length-1]);
             
			axios.post(API_URL+'/student-profile-pics-remove', data, axiosHeader)
			.then((response) => {
				//document.write(JSON.stringify(response.data));
				///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response && response.data.responseTxt=="success"){
					setPicture('');
					etlStudentObj.profilePic='';
					localStorage.setItem("etlStudentObj", JSON.stringify(etlStudentObj));
					return false;
				}else{
					setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Your file could not be removed.");			
					return false;
				}
			}).catch((error) => {
				setShowAlert(true);
				setAlertMessage(""+error);			
				return false;
			})	
		}		

	}


	function deleteReqAccount() {
		setDeleteAccountProgress(true);
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
					'loginId': etlStudentObj.loginId,
					'token': etlStudentObj.token,
					'device': 'web'
				}
			}; 			
			const data = new FormData();             
			axios.post(API_URL+'/delete-student-send-otp', data, axiosHeader)
			.then((response) => {
				setDeleteAccountProgress(false);
				if(response && response.data.responseTxt=="success"){
					setDeleteAccountToken(response.data.obj.token);
					childRefDeleteAccount.current.handleClickOpen();
					return false;
				}else{
					setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Something wrong, try after sometime");			
					return false;
				}
			}).catch((error) => {
				setSeverityAlert("error");
				setShowAlert(true);
				setAlertMessage(""+error);			
				return false;
			})	

	}


	// function undoDeleteReq() {
	// 	setUndoDeleteAccountProgress(true);
	// 		let axiosHeader = {
	// 			headers: {
	// 				'Content-Type': 'multipart/form-data',
	// 				'studentId': etlStudentObj.studentId,
	// 				'token': etlStudentObj.token,
	// 			}
	// 		}; 			
	// 		const data = new FormData();             
	// 		axios.post(API_URL+'/student-profile-delete-undo', data, axiosHeader)
	// 		.then((response) => {
	// 			setUndoDeleteAccountProgress(false);
	// 			if(response && response.status===200 && response.data.responseTxt==="success"){
	// 				etlStudentObj.deleteFlag = 0;
    //       			localStorage.setItem("etlStudentObj", JSON.stringify(etlStudentObj));
	// 				setSeverityAlert("success");
	// 				setShowAlert(true);
	// 				setAlertMessage("Account deletion request has been undo successfully.");
	// 				return false; 
	// 			}else{
	// 				setSeverityAlert("error");
	// 				setShowAlert(true);
	// 				setAlertMessage("Something wrong, try after sometime");			
	// 				return false;
	// 			}
	// 		}).catch((error) => {
	// 			setShowAlert(true);
	// 			setAlertMessage(""+error);			
	// 			return false;
	// 		})	

	// }


	function updateEmailFrm(){    
		childRefUpdateEmail.current.handleClickOpen();   
	}

	function updatePhoneFrm(){    
		childRefUpdatePhone.current.handleClickOpen();   
	}


	return (
		<div> 
			<MetaTags>
            	<title>Profile</title>
          	</MetaTags>				
			<Header />	
	   		<LeftDrawer />
			
		<main className={classes.content}>
        
				<Box style={{marginBottom:100, marginLeft:20, marginRight:20}}>	
					
					<Box mt={1}>
							<Grid container spacing={2}>
								<Grid item md={12} xs={12}>
									<h3 className="heading" >Profile</h3>
								</Grid>
							</Grid>
					</Box>

					<Box mt={1} >
						<Grid className="divBorderBox" container spacing={2}>
							{(!mobileOs || mobileOs!=='iOS')?	
								<Grid item md={6} xs={6} style={{textAlign:'center'}}>
									{(picture && picture.length>0)?<>
										<img src={picture} style={{maxHeight:150, borderRadius:10}} />
										<p style={{fontSize:20,color:'#FF0000',cursor:'pointer'}} title='Remove' ><i onClick={()=>{removeFile()}} className="fa fa-remove"></i></p>
										</>
									:<>Upload Your Picture<br/><input type="file" id="profilepic" onChange={(event)=>{uploadFile()}} /></>}
								</Grid>
							:null}	
								<Grid item md={(mobileOs && mobileOs==='iOS')?12:6} xs={(mobileOs && mobileOs==='iOS')?12:6}>
									Student Name: {etlStudentObj.studentName}<br/>
									Mobile: {etlStudentObj.phoneNo} 
									{(!etlStudentObj.phoneNo || etlStudentObj.phoneNo.length<1)?
										<Button onClick={()=>{updatePhoneFrm()}} style={{textTransform:'none',height:20,backgroundColor:'#008140',color:'#FFF',marginLeft:5}} size='small' variant='outlined' >Update Mobile</Button>
									:null}
									<br/>
									Email Id: {etlStudentObj.emailId}
										<Button onClick={()=>{updateEmailFrm()}} style={{textTransform:'none',height:20,backgroundColor:'#008140',color:'#FFF',marginLeft:5}} size='small' variant='outlined' >{etlStudentObj?.emailId?<>Update Email</>:<>Add Email</>}</Button>
								</Grid>
								<Grid item md={6} xs={6}>Link Id</Grid>
								<Grid item md={6} xs={6}>{etlStudentObj.loginId}</Grid>

							{(etlStudentObj.schools!=null && etlStudentObj.schools[0]!=null && etlStudentObj.schools[0].schoolName!=null)?
								<>
								<Grid item md={6} xs={6}>School</Grid>
								<Grid item md={6} xs={6}>{etlStudentObj.schools[0].schoolName}</Grid>
								</>
							:null}	

							{(etlStudentObj.schools!=null && etlStudentObj.schools[0]!=null && etlStudentObj.schools[0].className!=null)?
								<>
								<Grid item md={6} xs={6}>Class</Grid>
								<Grid item md={6} xs={6}>{etlStudentObj.schools[0].className}</Grid>
								</>
							:null}

								<Grid item md={6} xs={6}>Account Status</Grid>
								<Grid item md={6} xs={6}>									
									{etlStudentObj.deleteFlag?<b style={{color:'#FF0000'}}>Your account deletion process is started. It would be deleted in next few hours automatically</b>:<>{etlStudentObj.status} {deleteAccountProgress?<><CircularProgress size={20} /> Wait...</>:((etlStudentObj.phoneNo && etlStudentObj.phoneNo.length>0) || (etlStudentObj.emailId && etlStudentObj.emailId.length>0))?<Link href="javascript:;" style={{color:'#FF0000'}} onClick={()=>{deleteReqAccount()}} >Delete My Account</Link>:null}</>}
								</Grid>								
						</Grid>
					</Box>

				</Box>

		</main>

				<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

				<UpdateEmail ref={childRefUpdateEmail} heading={etlStudentObj?.emailId?<>Update Email</>:<>Add Email</>} />
				<UpdatePhone ref={childRefUpdatePhone} />
				<DeleteAccountOtp token={deleteAccountToken} ref={childRefDeleteAccount} />				
		</div>	
	);
  }